'use strict';

var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;

module.exports = function (str) {
	if (typeof str !== 'string') {
		throw new TypeError('Expected a string');
	}

	return str.replace(matchOperatorsRe, '\\$&');
};



//////////////////
// WEBPACK FOOTER
// C:/Agent0/_work/434/s/~/escape-string-regexp/index.js
// module id = ../../../../escape-string-regexp/index.js
// module chunks = 3